export default "__VITE_PUBLIC_ASSET__5a8d4b2c__"